// import { Container } from '@mui/material';
// import AdminTable from './AdminTable';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Card, CardHeader, CardContent, Button, Typography } from '@mui/material';

const AdminModule = () => {
  return (
    <>
      {/* <Container>
        <AdminTable />
      </Container> */}

      {/* 구글 시트 링크 추가 */}
      <Box sx={{ marginY: 5 }}>
        <Card>
          <CardHeader title="교과목 정보 확인" />
          <CardContent>
            <Typography variant="body1" sx={{ marginBottom: 2 }}>
              교과목 정보는 아래 링크에서 확인할 수 있습니다.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href="https://docs.google.com/spreadsheets/d/1bLUuPlZRgDTxLMKQEX4fQiMPDJOAr3bXP49d3OWsfZc/edit?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<OpenInNewIcon />}
            >
              교과목 정보 시트 열기
            </Button>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AdminModule;
